<template>
  <div class="sidebar">
    <div class="top">
      <b-img-lazy v-if="GET_IS_DARK_MODE" :src="require('@/assets/images/VOIPLogo-white.svg')" />
      <b-img-lazy v-else :src="require('@/assets/images/VOIP-Phone-Business-Logo.svg')" />
      <b-button variant="link" class="d-lg-none" @click="$emit('menu-close')">
        <b-icon icon="x" variant="danger" font-scale="2" />
      </b-button>
    </div>
    <div class="list">
      <ul>
        <router-link v-for="(data,index) in sidebar" :key="index" tag="li" class="cursor-pointer" :to="{ name: data.to.name }">
          <div>
            <b-icon :icon="data.icon" class="mr-2" />
            <span>{{data.text}}</span>
          </div>
        </router-link>
      </ul>
    </div>
    <div class="bottom">
      <div class="d-flex align-items-center justify-content-between w-100">
        <b-dropdown variant="none" toggle-tag="div" dropup no-caret toggle-class="bg-transparent d-flex align-items-center p-0 border-0">
          <template #button-content>
            <div v-if="GET_USER" class="d-flex align-items-center justify-content-between">
              <b-avatar badge-variant="info">
                <template v-if="GET_USER.role=='admin'" #badge>
                  <b-icon icon="app-star" />
                </template>
              </b-avatar>
              <div :class="{ 'text-white': GET_IS_DARK_MODE, }" class="ml-1" style="text-align: start;">
                <p class="text-decoration-none mb-0">{{GET_USER.first_name}} {{GET_USER.last_name}}</p>
                <span>{{GET_USER.username}}</span>
              </div>
              <div class="ml-1">
                <b-icon icon="caret-up-fill" :variant="GET_IS_DARK_MODE?'white':'black'" />
              </div>
            </div>
          </template>
          <b-dropdown-item @click="LOGOUT()" variant="danger">
            <b-icon-arrow-bar-left />
            Logout
          </b-dropdown-item>
        </b-dropdown>
        <div class="ml-1">
          <b-button variant="link" class="mr-2" @click="CHANGE_THEME()">
            <b-icon v-if="GET_THEME==themes.light.value" icon="sun-fill" />
            <b-icon v-else-if="GET_THEME==themes.dark.value" icon="app-dark-mode" />
            <b-icon v-else icon="circle-half" />
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CHANGE_THEME, GET_IS_DARK_MODE, GET_THEME, GET_USER, LOGOUT } from '@/store/constants'
import { mapGetters } from 'vuex'
import { sidebar, themes } from '@/constants'
import { mapActions } from 'vuex'
export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters([
      GET_USER,
      GET_THEME,
      GET_IS_DARK_MODE,
    ]),
    sidebar(){ return sidebar },
    themes(){ return themes },
  },
  methods: {
    ...mapActions([
      LOGOUT,
      CHANGE_THEME,
    ]),
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .sidebar {
    color: $white;
    > .list {
      > ul {
        // background: linear-gradient(to right,  $dark-card 0%,$dark-card 50%,$black 50%,$black 100%);
        > li {
          &:not(.router-link-exact-active):hover {
            background-color: rgba(0, 0, 0, 0.5);
          }
          &.router-link-exact-active {
            background-color: $black;
          }
        }
      }
    }
    > .bottom {
      > div {
        background-color: $black;
      }
    }
  }
}
.sidebar {
  grid-area: sideBar;
  color: $black;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 1rem;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 
    'sideBarTop'
    'sideBarList'
    'sideBarBottom'
  ;
  > .top {
    grid-area: sideBarTop;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
  }
  > .list {
    grid-area: sideBarList;
    overflow: auto;
    > ul {
      list-style: none;
      padding: 0px;
      > li {
        padding: 0.5rem;
        margin-top: 0.25rem;
        border-radius: 1rem;
        &:not(.router-link-exact-active):hover {
          background-color: rgba(0, 0, 0, 0.05);
        }
        &.router-link-exact-active {
          background-color: $white;
        }
      }
    }
  }
  > .bottom {
    grid-area: sideBarBottom;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    > div {
      background-color: $white;
      padding: 0.5rem;
      border-radius: 0.5rem;
    }
  }
}
</style>